import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";

const Page = ({ children, freeWidth = false, nav = false }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "auto",
        // backgroundColor: Colors.chillBlue,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      {nav ? <NavBar /> : null}
      <div
        style={{
          padding: 50,
          paddingTop: 10,
          maxWidth: freeWidth ? null : "800px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          //   backgroundColor: Colors.floatBg,
        }}
      >
        {children}
      </div>
      <Footer />
    </div>
  );
};
export default Page;
